export function chunk<T>(collection: T[], chunkSize: number): T[][] {
  return collection.reduce((accumulator, item) => {
    if (accumulator.length && accumulator[accumulator.length - 1].length < chunkSize) accumulator[accumulator.length - 1].push(item);
    else accumulator.push([item]);
    return accumulator;
  }, []);
}
